import * as React from 'react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { AnnouncementModalLayout, Box, Text } from 'wix-style-react';
import { moveToMainPage } from '../../../services/historyService';
import { generateUpgradeLink } from '../../../consts/external-links';
import Check from 'wix-ui-icons-common/Check';
import { useDispatch } from 'react-redux';
import { reportUpgradeButtonClick, reportUpgradeModalLoad } from '../../../redux/actions/bi.actions';
import { useEffect } from 'react';
import { ReactComponent as Upgrade } from '../../../assets/upgrade.svg';

interface IEnforceContributorsUpgrade extends InjectedTranslateProps {
  shouldRedirectToMainPageOnClose?: boolean;
  msid: string;
  contributorLimit: number;
  isFreePlan: boolean;
  origin: string;

  closeModal(): void;
}

const EnforceContributorsUpgrade: React.FC<IEnforceContributorsUpgrade> = ({ t, closeModal, shouldRedirectToMainPageOnClose, msid, contributorLimit, isFreePlan, origin }) => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(reportUpgradeModalLoad(origin));
  }, []);

  const onCloseClick = () => {
    closeModal();
    if (shouldRedirectToMainPageOnClose) {
      moveToMainPage();
    }
  };

  const openPackagePicker = () => {
    dispatch(reportUpgradeButtonClick(origin));
    window.open(generateUpgradeLink(msid), '_blank');
  };

  return (<AnnouncementModalLayout
      theme="premium"
      illustration={<Upgrade/>}
      title={t('upgrade_modal.enforceContributorsUpgrade.title')}
      primaryButtonText={t('upgrade_modal.enforceContributorsUpgrade.upgrade')}
      /*linkText={t('upgrade_modal.enforceContributorsUpgrade.learnMore')}*/
      primaryButtonOnClick={openPackagePicker}
      onCloseButtonClick={onCloseClick}
    >
      { isFreePlan ? <Box direction="vertical">
        <Box><Check/><Text>{t('upgrade_modal.enforceContributorsUpgrade.freePlan.firstPoint')}</Text></Box>
        <Box><Check/><Text>{t('upgrade_modal.enforceContributorsUpgrade.freePlan.secondPoint')}</Text></Box>
        <Box><Check/><Text>{t('upgrade_modal.enforceContributorsUpgrade.freePlan.thirdPoint')}</Text></Box>
      </Box> : <Text>
        {t('upgrade_modal.enforceContributorsUpgrade.content', { contributorLimit })}
      </Text> }
    </AnnouncementModalLayout>
  );
};

export default translate()(EnforceContributorsUpgrade);
